/* eslint-disable check-file/filename-naming-convention */

import "react-toastify/dist/ReactToastify.css";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider } from "react-router";
import { ToastContainer } from "react-toastify";
import { prefixer } from "stylis";

import { OfflineIndicator, Snackbar } from "@/atoms";
import { globalConstants } from "@/constants";
import { toggleThemeHandler } from "@/redux/actions";
import { Routes } from "@/routes";
import { darkTheme, lightTheme } from "@/theme";

const cacheLtR = createCache({
    key: "photoflare-dashboard-mui",
    stylisPlugins: [prefixer],
});

export const App = () => {
    const dispatch = useDispatch();

    const theme = useSelector(({ themeReducer }) => themeReducer.theme);

    useEffect(
        () => {
            if (localStorage.getItem(globalConstants.theme) && localStorage.getItem(globalConstants.theme) === globalConstants.dark) {
                dispatch(toggleThemeHandler());

                localStorage.setItem(
                    globalConstants.theme,
                    localStorage.getItem(globalConstants.theme),
                );
            } else {
                localStorage.setItem(
                    globalConstants.theme,
                    theme,
                );
            }
        },
        [],
    );

    return (
        <CacheProvider value={cacheLtR}>
            <ThemeProvider theme={theme === globalConstants.dark ? darkTheme : lightTheme}>
                <CssBaseline />
                <Snackbar />
                <RouterProvider router={Routes} />
                <ToastContainer
                    closeButton={false}
                    closeOnClick={false}
                    position="bottom-left"
                    theme={theme}
                    hideProgressBar
                />
                <OfflineIndicator />
            </ThemeProvider>
        </CacheProvider>
    );
};
